module.exports = __webpack_public_path__ + "img/zh-tw.b234dabd.png";